import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberComma'
})
export class NumberCommaPipe implements PipeTransform {
    transform(value: number | string | null | undefined): string {
        if (value === null || value === undefined || value === '') return '';

        const num = Number(value);
        if (isNaN(num)) return String(value);

        return num.toLocaleString('en-US'); // or 'en-US' if you prefer US grouping
    }
}
